/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import T from 'i18n-react';
import type { NextPage, NextPageContext } from 'next';

import ForgotPasswordMain from 'Components/ForgotPassword/ForgotPassword';
import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import texts from 'Components/texts.json';
import { PAGE_SLUGS } from 'Utilities/consts';
import type { GetInitialPropsMiddlewareContext } from 'Utilities/getInitialPropsMiddlewares/getInitialPropsMiddlewares.types';
import { unauthorisedOnly } from 'Utilities/getInitialPropsMiddlewares/unauthorisedOnly/unauthorisedOnly';
import { createMiddlewarePipeline } from 'Utilities/helpers/middlewarePipeline/middlewarePipeline';

T.setTexts(texts);

const ForgotPassword: NextPage = () => (
	<>
		<MetaTags
			// @ts-expect-error MetaTags needs to be rewritten to TS
			description={T.translate('metaTags.pages.forgotPassword.description')}
			ogTitle={T.translate('metaTags.pages.forgotPassword.title')}
			title={T.translate('metaTags.pages.forgotPassword.title')}
		/>
		<PageComposer pageSlug={PAGE_SLUGS.FORGOT_PASSWORD}>
			<ForgotPasswordMain />
		</PageComposer>
	</>
);

export const forgotPasswordGetInitialProps = async (context: NextPageContext): Promise<{}> => {
	const middlewarePipeline = createMiddlewarePipeline<GetInitialPropsMiddlewareContext>(unauthorisedOnly);

	const getInitialPropsMiddlewareContext: GetInitialPropsMiddlewareContext = {
		nextContext: context,
		returnValue: {},
	};

	await middlewarePipeline.run(getInitialPropsMiddlewareContext);

	return getInitialPropsMiddlewareContext.returnValue;
};

ForgotPassword.getInitialProps = forgotPasswordGetInitialProps;

export default ForgotPassword;
